import type { MutableRefObject } from "react";

const toolbarPressRegistry = new Map<string, MutableRefObject<boolean>>();

export function registerFormattingRailToolbarPress(
  blockId: string,
  ref: MutableRefObject<boolean>,
): () => void {
  toolbarPressRegistry.set(blockId, ref);
  return () => {
    toolbarPressRegistry.delete(blockId);
  };
}

export function beginFormattingRailToolbarPress(blockId: string): void {
  const ref = toolbarPressRegistry.get(blockId);
  if (ref !== undefined) {
    ref.current = true;
  }
}

export function endFormattingRailToolbarPress(blockId: string): void {
  const ref = toolbarPressRegistry.get(blockId);
  if (ref !== undefined) {
    queueMicrotask(() => {
      ref.current = false;
    });
  }
}
